module.exports = __webpack_public_path__ + "img/bag-magic-powder.734f84f6.svg";